import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useApi from "@/utils/useApi";
import apis from "@/utils/apis";
import { setConfig, setConfigLoading, setConfigError } from "@/store/slices/configSlice";

/**
 * Custom hook to fetch and manage app configuration
 * - Fetches app config in background (non-blocking)
 * - Silently fails if API is unavailable
 */
const useApp = () => {
  const { callApi } = useApi();
  const dispatch = useDispatch();
  const config = useSelector((state) => state.config.config);

  // Fetch app config on mount - non-blocking, runs in background
  useEffect(() => {
    if (!config) {
      callApi({ api: apis.getConfig })
        .then((response) => {
          if (response) {
            dispatch(setConfig(response));
          }
        })
        .catch((error) => {
          console.warn("Config API unavailable:", error?.message || "Failed to load config");
          dispatch(setConfigError(error?.message || "Failed to load config"));
        })
        .finally(() => {
          dispatch(setConfigLoading(false));
        });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useApp;
